import axios from 'axios';
import { create } from 'zustand';

type TShopperApprovedResponse = {
    'site_id': string;
    'site_label': string;
    'site_url': string;
    '5_star': number;
    '4_star': number;
    '3_star': number;
    '2_star': number;
    '1_star': number;
    'total_reviews': number;
    'average_rating': number;
};

const SA_API = 'https://api.shopperapproved.com/aggregates/reviews/23579?token=4rWtG8fwcn52qCp';

interface ShopperApprovedState {
    data?: TShopperApprovedResponse;
    recommendedRate: string;
}

interface ShopperApprovedActions {
    getSAData: () => void;
}

type ShopperApprovedStore = ShopperApprovedState & ShopperApprovedActions;

const initialState: ShopperApprovedState = {
    recommendedRate: '',
};

export const fetchSAData = async (): Promise<TShopperApprovedResponse | null> => {
    try {
        const { data } = await axios.get<TShopperApprovedResponse>(SA_API);
        return data;
    } catch (error) {
        return null;
    }
};

export const useShopperApprovedStore = create<ShopperApprovedStore>()((set) => ({
    ...initialState,
    getSAData: async () => {
        const saRes = await fetchSAData();

        if (saRes) {
            const newRecomRate = ((saRes['4_star'] + saRes['5_star']) / saRes.total_reviews) * 100;

            set({
                data: saRes,
                recommendedRate: `${newRecomRate ? Math.round(newRecomRate) : 96}%`,
            });
        } else {
            console.error('Error to fetch shopper approved data!');
        }
    },
}));
